export default "__VITE_ASSET__BkMiY5nD__"